import Vue from "vue";
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faSpinner,
	faCaretLeft,
	faCaretRight,
	faPowerOff,
	faTrash,
	faMinus,
	faPlus,
	faExclamationTriangle,
	faCog,
	faHome,
	faBars,
	faReceipt,
	faSave,
	faArrowRight,
	faCertificate,
	faMapMarkerAlt,
	faEdit,
	faArrowLeft,
	faUndo,
	faTimes,
	faText,
	faAsterisk,
	faFilePdf,
	faCheck,
	faQuestion,
	faHistory,
	faUpload,
	faCheckSquare,
	faTrashUndo,
	faSignature,
	faAward,
	faSync,
	faCogs,
	faLevelUp,
	faBook
} from "@fortawesome/pro-solid-svg-icons";
import {
	faCalendarAlt,
	faUser,
	faSearch,
	faEnvelope,
	faPhone,
	faCalendarCheck,
	faEye,
	faClone,
	faQuoteLeft,
	faQuoteRight,
	faMinusCircle,
	faSpellCheck,
	faStamp,
	faClock,
	faDownload,
	faFolderOpen
} from "@fortawesome/pro-regular-svg-icons";
import {
	faBoxes,
	faBuilding,
	faFileCertificate,
	faUsers,
	faUserHardHat,
	faFileContract,
	faFaucet,
	faFlagCheckered,
} from "@fortawesome/pro-light-svg-icons";
import { } from "@fortawesome/free-brands-svg-icons";
import { faGripVertical } from "@fortawesome/pro-duotone-svg-icons";

Vue.component("fa", FontAwesomeIcon);
Vue.component("fa-layers", FontAwesomeLayers);
Vue.component("fa-layers-text", FontAwesomeLayersText);

library.add(
	faSpinner,
	faCaretLeft,
	faCaretRight,
	faPowerOff,
	faTrash,
	faMinus,
	faPlus,
	faExclamationTriangle,
	faGripVertical,
	faUser,
	faUsers,
	faBoxes,
	faCog,
	faCalendarAlt,
	faHome,
	faBars,
	faReceipt,
	faBuilding,
	faSave,
	faSearch,
	faArrowRight,
	faCertificate,
	faFileCertificate,
	faMapMarkerAlt,
	faSearch,
	faEdit,
	faArrowLeft,
	faUndo,
	faTimes,
	faUserHardHat,
	faEnvelope,
	faPhone,
	faCalendarCheck,
	faText,
	faFileContract,
	faFaucet,
	faAsterisk,
	faFilePdf,
	faEye,
	faCheck,
	faClone,
	faQuestion,
	faHistory,
	faUpload,
	faQuoteLeft,
	faQuoteRight,
	faAward,
	faCheckSquare,
	faMinusCircle,
	faSpellCheck,
	faStamp,
	faTrashUndo,
	faSignature,
	faFlagCheckered,
	faClock,
	faSync,
	faCogs,
	faDownload,
	faLevelUp,
	faBook,
	faFolderOpen,
);

export default {};
